import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShieldcheckIcon from 'icons/Shieldcheck.icon';
import ProgressBar from 'components/ProgressBar';

import './CardWrapper.styles.scss';
import './CardWrapper.styles.responsive.scss';

type CardWrapperProps = {
  className?: string;
  title?: string;
  hasNDA?: boolean;
};

const CardWrapper: React.FC<CardWrapperProps> = (props) => {
  const { children, className, title, hasNDA = false } = props;

  const classes = classNames('card-wrapper', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="shield">
        <ShieldcheckIcon />
        <span>{t('secureLink')}</span>
      </p>

      {title && <p className="title">{title}</p>}

      {hasNDA && <ProgressBar percentage={50} />}

      {children}
    </div>
  );
};

export default CardWrapper;
